import React, { useState, useEffect } from "react";
import { getRegionals } from "../../actions/regional-actions";
import { TablePagination, Typography } from "@material-ui/core";
import KeyboardArrowLeft from "@material-ui/icons/KeyboardArrowLeft";
import KeyboardArrowRight from "@material-ui/icons/KeyboardArrowRight";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import FirstPageIcon from "@material-ui/icons/FirstPage";
import LastPageIcon from "@material-ui/icons/LastPage";
import IconButton from "../../utils/form/IconButton";
import { useStateValue } from "../../context/store";
import Search from "../../images/icons/search.svg";
import RegionalSearch from "./searchRegional";
import CreateRegional from "./createRegional";
import TableRegional from "./tableRegional";
import { headers } from "./dataRegional";
import PropTypes from "prop-types";
import { styles } from '../styles';
import { permissionsConstans } from "../../constansPermissions";

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),
  },
}));

function TablePaginationActions(props) {
  const classes = useStyles1();
  const theme = useTheme();
  const { count, page, rowsPerPage, onChangePage } = props;

  const handleFirstPageButtonClick = (event) => {
    onChangePage(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onChangePage(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onChangePage(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onChangePage(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <div className={classes.root}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowRight />
        ) : (
          <KeyboardArrowLeft />
        )}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? (
          <KeyboardArrowLeft />
        ) : (
          <KeyboardArrowRight />
        )}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </div>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onChangePage: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

export default function Regional(props) {
  const classes = styles();
  const [page, setPage] = useState(0);
  const [messageOpen, setMessageOpen] = useState(false);
  const [stateEdit, setStateEdit] = useState(false);
  const [resetTable, setResetTable] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [resultSearch, setResultSearch] = useState([]);
  const [regionales, setRegionales] = useState([]);
  const [{}, dispatch] = useStateValue();
  const [message, setMessage] = useState({
    open: false,
    text: "",
    type: "",
    fontColor: "",
  });

  const rows = resultSearch;

  const emptyRows =
    rowsPerPage -
    Math.min(rowsPerPage, rows?.length || [] - page * rowsPerPage);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const refreshRegional = () => setStateEdit(!stateEdit);
  const dataFilter = (x) => setResultSearch(x);
  const refresPaginator = () => setResetTable(!resetTable);

  const validationPermissionCreate = () => {
    const state = JSON.parse(localStorage.getItem("state"))
    const module = state?.permissions.find((x)=> x.code === 'REG')
 
   if(module?.functionalities?.some((x)=> x === permissionsConstans.REG_CREAR)){

      return <React.Fragment>
                <Typography className={classes.titleCreate}>
                Registro nuevo regional
                </Typography>
              <CreateRegional stateEdit={refreshRegional} />
            </React.Fragment>    
      
  };
   }

   const validationPermissionSearch = () => {
    const state = JSON.parse(localStorage.getItem("state"))
    const module = state?.permissions.find((x)=> x.code === 'REG')
 
  if(module?.functionalities?.some((x)=> x === permissionsConstans.REG_CONSULTAR)){
     return <React.Fragment>
              <Typography className={classes.titleCreate}>
                Información regionales
              </Typography>
              <RegionalSearch
                stateEdit={refreshRegional}
                dataFilter={dataFilter}
                currentData={regionales}
                refresPaginator={refresPaginator}
              />
           </React.Fragment>
   }  
   };
   
  useEffect(() => {
    const getAllRegional = async () => {
      const response = await getRegionals();
      if (response?.status > 399 && response?.status !== 401 && response?.status !==403) {
        setMessage({
          open: true,
          text: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
          type: "error",
          fontColor: "#fff",
        });
        setMessageOpen(true);
      }
      setRegionales([...response.data.regionalList]);
      setResultSearch([...response.data.regionalList]);
    };
    getAllRegional();
    setPage(0);
   
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Regionales",
      breadCrumbSubText: "Regionales",
      index: 2,
    });
  }, [!stateEdit]);

  useEffect(() => {
    setPage(0);
  }, [!resetTable]);

  return (
    <div style={{ marginTop: "40px" }}>
      {validationPermissionCreate()}
      {validationPermissionSearch()}
      {(rowsPerPage > 0
        ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        : rows
      ).map((row, index) => (
        <TableRegional
          headers={headers}
          data={row}
          stateEdit={refreshRegional}
          // onView={verRequisicion}
          // onDelete={anularRequisicionConfirm}
        />
      ))}
      {rows.length !== 0 ? (
        <TablePagination
          style={{ display: "flex", justifyContent: "center" }}
          rowsPerPageOptions={[5, 10, 15]}
          count={rows.length}
          labelRowsPerPage='Registros por página'
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      ) : (
        <React.Fragment>
          <div className={classes.messageSearch}>
            <img src={Search} alt="" />
            <Typography style={{ paddingTop: "20px", paddingLeft: "20px" }}>
              No se encontraron registros que coincidan con el filtro de
              búsqueda aplicado
            </Typography>
          </div>
        </React.Fragment>
      )}
    </div>
  );
}
